/**
 * @file   src\components\MemberWantAd\CreateNewBtn.js
 * @brief  This file is responsible for create want ad label.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import CreatePlusIcon from "../../images/create-plus-icon.svg";

const CreateNewBtn = (props) => {
  const { handleContinueClick, labelText } = props;
  return (
    <a
      role="button"
      href={void 0}
      className="create-new-btn mb-3"
      onClick={() => handleContinueClick()}
    >
      <span className="create-plus-icon">
        <img src={CreatePlusIcon} />
      </span>
      {labelText || "Create New Want-Ad"}
    </a>
  );
};
export default CreateNewBtn;
